<div fxLayout="row">
  <div fxFlex="93">
    <h1>{{ data.LastName }} {{ data.FirstName }}</h1>
    <h2>{{ data.Title | translate }}</h2>
  </div>
  <div fxFlex="7">
    <button mat-icon-button color="primary" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div fxLayout="column" fxLayoutGap="10px">
  <form [formGroup]="formGroup">
    <app-legalization-file-type-selector
      [disabled]="data.IsCorrection"
      [selectedTypeId]="selectedDocument?.LegalizationDocumentTypeId"
      (typeSelected)="onLegalizationTypeSelected($event)"
      >
    </app-legalization-file-type-selector>

    @if (description.value) {
      <mat-form-field appearance="outline" fxFill class="readonly-field">
        <mat-label>{{ 'Legalization.DocumentDescription' | translate }}</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          formControlName="description"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
          readonly
        ></textarea>
      </mat-form-field>
    }

    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field fxFlex="50" appearance="outline">
        <mat-label>{{ 'Legalization.StartDate' | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="startDatePicker"
          formControlName="startDate"
          autocomplete="date"
          [matDatepickerFilter]="documentStartDateFilter"
          />
          <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker startView="multi-year"></mat-datepicker>
          @if (!startDate || (startDate.invalid && startDate.touched)) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ 'Legalization.EndDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" autocomplete="date" [matDatepickerFilter]="documentEndDateFilter" />
          <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker startView="multi-year"></mat-datepicker>
          @if (!endDate || (endDate.invalid && endDate.touched)) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ 'Legalization.DocumentNumber' | translate }}</mat-label>
          <input matInput type="text" formControlName="documentNumber" />
          @if (documentNumber.invalid && documentNumber.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ 'Legalization.SubmissionDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="submissionDatePicker" formControlName="submissionDate" autocomplete="date" />
          <mat-datepicker-toggle [for]="submissionDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #submissionDatePicker startView="multi-year"></mat-datepicker>
          @if (submissionDate.invalid && submissionDate.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" fxFill>
        <mat-label>{{ 'Legalization.Comment' | translate }}</mat-label>
        <textarea
          matInput
          [maxLength]="300"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          formControlName="comment"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
        ></textarea>
        @if (comment.invalid && comment.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
      <div>
        <mat-radio-group formControlName="documentCategory" required>
          <mat-radio-button value="1">{{ 'Legalization.StayLegalization' | translate }}</mat-radio-button>
          <mat-radio-button value="2">{{ 'Legalization.WorkLegalization' | translate }}</mat-radio-button>
          <mat-radio-button value="3">{{ 'Legalization.StayAndWorkLegalization' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" [style.margin-top.px]="12">
        <mat-form-field fxFlex="50" appearance="outline" fxFill>
          <mat-label>{{ 'Legalization.DocumentStatus' | translate }}</mat-label>
          <mat-select formControlName="documentStatus" required>
            @for (status of listOfLegalizationDocumentStatuses$ | async; track status) {
              <mat-option [value]="status.Id">
                {{ status.Name }}
              </mat-option>
            }
          </mat-select>
          @if (status.invalid && status.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline" fxFill>
          <mat-label>{{ 'Legalization.LegalizationStatus' | translate }}</mat-label>
          <mat-select formControlName="status" required>
            @for (status of listOfLegalizationStatuses$ | async; track status) {
              <mat-option [value]="status.Id">
                {{ status.Name }}
              </mat-option>
            }
          </mat-select>
          @if (status.invalid && status.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" [style.margin-top.px]="12">
        <mat-form-field fxFlex="50" appearance="outline" fxFill>
          <mat-label>{{ 'Legalization.ActiveAlert' | translate }}</mat-label>
          <mat-select formControlName="alertStatusId">
            @for (status of listOfLegalizationAlertStatusesForForms$ | async; track status) {
              <mat-option [value]="status.Id">
                {{ status.Name }}
              </mat-option>
            }
          </mat-select>
          @if (status.invalid && status.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <app-agreements-section
        [preSelectedAgreements]="preSelectedArray"
        [workerId]="data.WorkerId"
        (agreementsSelectionChange)="onAgreementsSelectionChange($event)"
        [disabled]="data.IsCorrection"
        >
      </app-agreements-section>

      <div>
        <ng-container>
          <div class="active-files-section">
            <div class="active-files-header">
              <strong>{{ 'Legalization.ActiveDocuments' | translate }}</strong>
            </div>
            <hr />
            <section class="active-files-grid">
              @for (file of listOfWorkerLegalizationActiveFiles$ | async; track file) {
                <div class="grid-row">
                  <div class="document-name-column" [matTooltip]="file.DocumentType" matTooltipPosition="above">
                    {{ file.DocumentType }}
                  </div>
                  @if (file.StartDate || file.EndDate) {
                    <div
                      class="dates-column"
                      [matTooltip]="(file.StartDate | date : 'dd.MM.yyyy') + ' - ' + (file.EndDate | date : 'dd.MM.yyyy')"
                      matTooltipPosition="above"
                      >
                      {{ file.StartDate | date : 'dd.MM.yyyy' }} - {{ file.EndDate | date : 'dd.MM.yyyy' }}
                    </div>
                  }
                </div>
              }
            </section>
          </div>
        </ng-container>
      </div>
    </form>
    <div fxFill>
      <fileUpload [maxFileCount]="maxFileCount$ | async" (onFilesChange)="onFilesChange($event)"></fileUpload>
    </div>

    <div class="header-wrapper"></div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
      <button mat-raised-button (click)="onClose()">
        {{ 'Cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="createLegalizationDocument()" [disabled]="!isSendWorkerFileButtonEnabled()">
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>
